(() => {
  if (window.LightLoreHomeProcess) {
    window.LightLoreHomeProcess.scan();
    return;
  }

  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = () => Boolean(navigator.connection && navigator.connection.saveData);
  const observed = new WeakSet();
  const active = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const video = entry.target;
      if (!entry.isIntersecting) {
        video.pause();
      } else if (video.dataset.llManual !== 'true' && !motionPreference.matches && !saveData()) {
        video.play().catch(() => {});
      }
    }
  }, { rootMargin: '150px 0px', threshold: 0.15 }) : null;

  function scan() {
    document.querySelectorAll('.ll-clear-process .ll-process-media video').forEach((video) => {
      if (observed.has(video)) return;
      observed.add(video);
      active.add(video);
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.controls = true;
      video.muted = true;
      video.playsInline = true;
      const poster = video.closest('.ll-process-media')?.dataset.videoPoster;
      if (poster) video.poster = poster;
      video.addEventListener('pointerdown', () => { video.dataset.llManual = 'true'; });
      video.addEventListener('keydown', (event) => {
        if (['Enter', ' ', 'Spacebar', 'ArrowLeft', 'ArrowRight'].includes(event.key)) video.dataset.llManual = 'true';
      });
      if (observer) observer.observe(video);
    });
  }

  motionPreference.addEventListener('change', () => {
    if (motionPreference.matches) {
      active.forEach((video) => { if (video.dataset.llManual !== 'true') video.pause(); });
    }
  });
  document.addEventListener('shopify:section:load', scan);
  window.LightLoreHomeProcess = { scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
